import styled from "styled-components";
import Button from "../Button";
import { darken } from "polished";
import { Link } from "react-router";

export const Wrapper = styled.div`
  display: none;

  @media (max-width: 1048px) {
    display: flex;
    justify-content: space-between;
    box-shadow: 0px 5px 10px 0px rgb(0 0 0 / 25%);
    z-index: 1000;
    padding: 0 ${({ theme }) => theme.spacing[4]};
    background-color: ${({ theme }) =>
      theme.colors.background.grundfos.primary};
  }
`;

export const SwitchButton = styled(Button)`
  background-color: ${({ theme }) =>
    darken(0.04, theme.colors.background.grundfos.primary)};
  margin-right: ${({ theme }) => theme.spacing[4]};
  transition: all 0.2s ease-in-out;
  color: #fff;
  border-radius: 0;

  &:hover:not([disabled]) {
    background-color: ${({ theme }) =>
      darken(0.06, theme.colors.background.grundfos.primary)};
  }
`;

export const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--side-navigation-width);
  height: var(--side-navigation-width);

  @media (max-width: 1048px) {
    display: none;
  }
`;

export const Spacer = styled.div`
  flex: 1;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const SwitcherWrapper = styled.div`
  display: none;

  @media (max-width: 1048px) {
    display: block;
  }
`;
